import { getImageDimensions } from "@sanity/asset-utils";
import React from "react";
import { urlFor } from "./utils";
import { AccordionList, GridImage, Map } from "../../components";

export const getPortableText = (url, data) => {
  if (url === "/about" || url === "/a-propos") {
    return data?.whatIsLewootrack;
  }
  if (url === "/about/informations" || url === "/a-propos/informations") {
    return {
      title: data?.informations?.title?.toString().split("-")[0],
      block: data?.informations?.block,
    };
  }
  if (url === "/about/subscription" || url === "/a-propos/souscription") {
    return data?.subscription;
  }
  if (url === "/about/delevery" || url === "/a-propos/livraison") {
    return data?.delevery;
  }
  if (
    url === "/about/general-conditions" ||
    url === "/a-propos/conditions-generales"
  ) {
    return data?.generalConditons;
  }

  return data?.whatIsLewootrack;
};
export const getPortableText2 = (field, data) => {
  if (field === "whatIsLewootrack") {
    return data?.whatIsLewootrack;
  }
  if (field === "informations") {
    return {
      title: data?.informations?.title?.toString().split("-")[0],
      block: data?.informations?.block,
    };
  }
  if (field === "subscription") {
    return data?.subscription;
  }
  if (field === "delevery") {
    return data?.delevery;
  }
  if (field === "generalConditions") {
    return data?.generalConditons;
  }

  return data?.whatIsLewootrack;
};

export const getPortableTextFollows = (url, data) => {
  if (
    url === "/track-everything/how-it-is-work" ||
    url === "/suivez-tout/comment-marche-t-il"
  ) {
    return data?.howItIsWork;
  }
  if (
    url === "/track-everything/client-service" ||
    url === "/suivez-tout/service-client"
  ) {
    return data?.clientService;
  }
  return data?.howItIsWork;
};

export const getPortableActivityDetails = (data, id) => {
  for (const activity of data?.activities) {
    if (activity.text["_id"] === id) {
      return { title: activity.text.title, block: activity.text.block };
    }
  }
  return null;
};

// Barebones lazy-loaded image component
const SampleImageComponent = ({ value, isInline }) => {
  // console.log("SampleImageComponent --- ", value);
  if (!value?.asset) return null;
  const { width, height } = getImageDimensions(value);
  // console.log("SampleImageComponent 2--- ", value);
  return (
    <div className={`py-8`}>
      <div className={`flex justify-center`}>
        <img
          src={urlFor(value).fit("max").url()}
          loading="lazy"
          alt=""
          style={{
            // Display alongside text if image appears inside a block text span
            display: isInline ? "inline-block" : "block",
            resize: "both",

            // Avoid jumping around with aspect-ratio CSS property
            aspectRatio: width / height,
          }}
        />
      </div>
    </div>
  );
};
const ResizeImageComponent = ({ value }) => {
  // console.log("ResizeImageComponent --------------- ", value);
  if (!value?.image || (value?.image && !value?.image?.asset)) return null;
  const image = value.image;
  const { width, height } = getImageDimensions(image);
  return (
    <div className="py-8">
      <div className="flex justify-center">
        <img
          src={urlFor(image).fit("max").url()}
          loading="lazy"
          alt=""
          style={{
            resize: "both",
            aspectRatio: width / height,
            ...(value?.width && value?.width > 0 && { width: value.width }),
            ...(value?.height && value?.height > 0 && { height: value.height }),
          }}
        />
      </div>
    </div>
  );
};

// Barebones lazy-loaded image component
const SampleContactComponent = ({ value }) => {
  return (
    <div className={`inline-flex items-center`}>
      <img
        src={urlFor(value.image).fit("max").url()}
        loading="lazy"
        height={25}
        width={25}
        alt=""
      />
      <span className="text-base">{value.value}</span>
    </div>
  );
};

const AccordionComponent = ({ value }) => {
  const accordion = value?.accordion;
  // console.log("AccordionComponent --------------- ", accordion);

  return (
    <div className={`bg-white`}>
      <AccordionList data={accordion.content} />
    </div>
  );
};

const GridImagesComponent = ({ value }) => {
  const grid = value?.grid;
  // console.log("GridImagesComponent --------------- ", grid);
  return (
    <div className={`bg-white`}>
      <GridImage data={grid.content} />
    </div>
  );
};

const SampleLocationComponent = ({ value }) => {
  return (
    <div className="py-4">
      <Map
        lat={value?.location.lat}
        lng={value?.location.lng}
        adrress={value?.address}
      />
    </div>
  );
};

export const components = (isMobile) => {
  return {
    types: {
      image: SampleImageComponent,
      contact: SampleContactComponent,
      map: SampleLocationComponent,
      accordionList: AccordionComponent,
      gridImage: GridImagesComponent,
      resizeImage: ResizeImageComponent,
      // Any other custom types you have in your content
      // Examples: mapLocation, contactForm, code, featuredProjects, latestNews, etc.
    },
    marks: {
      // Ex. 1: custom renderer for the em / italics decorator
      em: ({ children }) => (
        <em className="text-gray-600 font-semibold">{children}</em>
      ),
      strong: ({ children }) => (
        <span className="text-base font-bold">{children}</span>
      ),
      underline: ({ children }) => (
        <span className="underline underline-offset-2">{children}</span>
      ),

      // Ex. 2: rendering a custom `link` annotation
      link: ({ value, children }) => {
        const target = (value?.href || "").startsWith("http")
          ? "_blank"
          : undefined;
        return (
          <a
            href={value?.href}
            className="text-blue-700 font-semibold"
            target={target}
          >
            {children}
          </a>
        );
      },
    },
    block: {
      // Ex. 1: customizing common block types
      h1: ({ children }) => (
        <h1 className="text-3xl font-semibold my-2">
          {children}
          <br />
        </h1>
      ),

      h2: ({ children }) => (
        <h2 className="text-2xl font-semibold my-2">{children}</h2>
      ),
      h3: ({ children }) => (
        <h3 className="text-xl font-semibold my-2">
          {children}
          <br />
        </h3>
      ),
      h4: ({ children }) => (
        <h4 className="text-lg font-semibold my-2">
          {children}
          <br />
        </h4>
      ),
      blockquote: ({ children }) => (
        <blockquote className="border-l-purple-500">{children}</blockquote>
      ),

      // Ex. 2: rendering custom styles
      customHeading: ({ children }) => (
        <h2 className="text-lg text-primary">{children}</h2>
      ),
      p: ({ children }) => (
        <p className="text-lg text-primary  py-2">{children}</p>
      ),
      normal: ({ children }) => <p className="py-2">{children}</p>,
    },

    list: {
      // Ex. 1: customizing common list types
      bullet: ({ children }) => (
        <ul className="xl:mt-1 my-list-style">{children}</ul>
      ),
      number: ({ children }) => <ol className="lg:mt-1">{children}</ol>,

      // Ex. 2: rendering custom lists
      checkmarks: ({ children }) => (
        <ol className="m-auto text-lg">{children}</ol>
      ),
    },

    listItem: {
      // Ex. 1: customizing common list types
      bullet: ({ children }) => (
        <li
          className={`${isMobile ? "ml-4" : "ml-12"} my-list-style`}
          // style={{ listStyle: two-apples}} // circlegeorgian  disclosure-open disc disclosure-closed \1F44D \1FAF1 kannada custom-counter-style
        >
          {children}
        </li>
      ),

      // Ex. 2: rendering custom list items
      checkmarks: ({ children }) => <li>✅ {children}</li>,
    },
    hardBreak: false,
  };
};
